var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.891 14.824A1.253 1.253 0 012 13.748V2.252a1.253 1.253 0 011.913-1.063l9.421 5.692a1.273 1.273 0 010 2.238l-9.43 5.698-.013.007z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjg5MSAxNC44MjRBMS4yNTMgMS4yNTMgMCAwIDEgMiAxMy43NDhWMi4yNTJhMS4yNTMgMS4yNTMgMCAwIDEgMS45MTMtMS4wNjNsOS40MjEgNS42OTJhMS4yNzMgMS4yNzMgMCAwIDEgMCAyLjIzOGwtOS40MyA1LjY5OC0uMDEzLjAwN3oiLz4KPC9zdmc+Cg==";
export { SvgPlay as ReactComponent };